$(document).ready(function () {

    $(".site-search-results").each(function () {
        var targetId = $(this).attr("id")
        loadResults("#" + targetId);
    });

    $(".site-search-loadmore").click(function (e) {
        e.preventDefault();
        var targetId = $(this).attr("href");
        loadResults(targetId);
    });

    $("#search-results-clear").click(function () {
        $("input[name='q']").val("");
        $("#search-results-clear").hide();
    });

    function hideShowInputClear(element) {
        var selector = $(element).attr('data-input-clear-watcher');
        var searchValue = $(element).val();

        var targetElement = $(selector);

        if (searchValue) {
            $(targetElement).show();
        } else {
            $(targetElement).hide();
        }
    }

    $("[data-input-clear-watcher]").each(function () {
        hideShowInputClear($(this));
    });

    $("[data-input-clear-watcher]").on('propertychange change keyup input paste', throttle(function () {
        hideShowInputClear($(this));
    }, 1000));

    $("[data-input-clear]").click(function () {
        var selector = $(this).attr('data-input-clear');
        var targetElement = $(selector);

        $(targetElement).val("");
        $(this).hide();
    });

    $(".input-group input").on('focusin focus', function () {
        $(this).closest('.input-group').addClass("input-focused");
    });

    $(".input-group input").on('focusout', function () {
        $(this).closest('.input-group').removeClass("input-focused");
    });
});

function loadResults(targetId) {
    var container = $(targetId);
    var keywords = container.attr("data-search-keyword");
    var page = container.attr("data-search-page");
    var pageSize = container.attr("data-search-page-size");
    var url = "/api/sitecore/BccSearch/Api?q=" + keywords + "&p=" + page;
    $.get(url, function (data) {
        for (var i = 0; i < data.length; i++) {
            var item = data[i];
            var summary = item.Summary ? item.Summary : "";
            container.append(`<a href="${item.Link}"><h3>${item.Title}</h3><div>${item.FullLink}</div><p>${summary}</p></a>`);
            var nextPage = Number(page) + 1;
            container.attr("data-search-page", nextPage);
        }
        if (data.length < pageSize) {
            container.next().hide();
        }
    })
    .fail(function () {
        alert("A search error occurred.");
    });
}